import request, { get } from './request'

export const getProjects = ({ pageNum, pageSize }) => {
  return get(`/api/v1/iot/projects`, {
    pageNum,
    pageSize,
  })
}

export const getRecent = () => {
  return get('/api/v1/iot/projects/recent', {
    num: 6,
  })
}

export const getDetail = (id) => {
  return get(`/api/v1/iot/project`, {
    id,
  })
}

export const onGoIng = () => {
  return get('/api/v1/iot/projects/ongoing')
}

export const getDevices = (projectId) => {
  return get('/api/v1/iot/devices', {
    projectId,
  })
}

export const apply = (body) => {
  return request({
    method: 'POST',
    url: `/api/v1/iot/application`,
    body,
  })
}
